<template>
  <el-dialog 
  v-if="!underConstruction"
  v-model="isvisible"
  :visible.sync="isvisible" 
  :show-close="restrictedTime?true:true"
  :close-on-click-modal="false"
  :close-on-press-escape="false"
  :lock-scroll="false"
  append-to-body
  :class="isMobile ? 'rcdialog rcmobile' : 'rcdialog' "
  @close="closeRC(false)"
  >
    <div slot="title">
      <h3>{{activeServices.dtl.rc_nm}} ({{ activeServices.dtl.periode }})</h3>
    </div>
    <h3>Service Name : {{activeServices.dtl.service_nm}}</h3>
    <div>
    <el-divider content-position="right">{{ 'Service Rating - '+ (activeServices.index+1) }}/{{ params.data.length }}</el-divider>
  </div>
    <!-- <div style="font-weight: bold;display: flex;justify-content: end;margin-top:15px">{{ 'Service Rating - '+ (activeServices.index+1) }}/{{ params.data.length }}</div> -->
    <div>
      <!-- <el-card>
        <div slot="header" class="stepTitle">
          <el-button type="text" icon="el-icon-back" circle 
            :disabled="activeServices.index==0" style="font-size: 1.1rem;"
            @click="prev"></el-button>
          <h3 class="t-center">{{ activeServices.dtl.service_nm }}</h3>
          <el-button type="text" icon="el-icon-right" circle style="font-size: 1.1rem;"
            :disabled="isEndRC"
            @click="(e)=>{next(e)}"></el-button>
        </div>
        <el-collapse v-model="activeServices.activeNames">
          <el-collapse-item v-for="(item, index) in activeServices.dtl.criteria" :key="index" :title="item.measure" :name="index">
            <div class="essayContent">
              <el-rate v-model="item.ratting_value" class="rating-val essayContent-input"></el-rate>
              <el-input type="textarea" v-model="item.note" placeholder="Type note here" class="essayContent-input"></el-input>
            </div>
          </el-collapse-item>
        </el-collapse>
      </el-card> -->
      <el-table
        :data="activeServices.dtl.criteria"
        :show-header="false"
        style="width: 100%">
        <el-table-column label="Date">
          <template slot-scope="scope">
            <div style="display: flex;">
              <div style="margin-right: 1px;width: 20px!important;">
                {{(scope.$index+1)}}.
              </div>
              <div style="width: 100%;">
                <div style="word-break: break-word;text-align: justify;">
                  {{ scope.row.measure }}
                  <el-tooltip class="item" effect="light" placement="bottom">
                    <i class="el-icon-info h-tooltips"></i>
                    <div slot="content" class="content-tooltips">
                      {{scope.row.description}}
                    </div>
                  </el-tooltip>
                </div>
                <div class="essayContent">
                  <el-rate v-model="scope.row.ratting_value" @change="(e)=>{changerate(e,scope.$index)}" class="rating-val essayContent-input"></el-rate>
                  <div>
                    <el-form>
                      <el-form-item :error="activeServices.dtl.criteria[scope.$index].isInvalid_entry">
                        <el-input type="text" v-model="scope.row.note" @input="(e)=>{validatenote(e,scope.$index)}" :ref="'inputcauses'+scope.$index" placeholder="Type note here" class="essayContent-input"></el-input>
                      </el-form-item>
                    </el-form>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button type="info" icon="el-icon-back" circle 
        :disabled="activeServices.index==0" style="font-size: 1.1rem;"
        @click="prev"></el-button>
      <el-button type="success" icon="el-icon-right" circle style="font-size: 1.1rem;"
        :disabled="isEndRC"
        @click="(e)=>{next(e)}"></el-button>
    </div>
  </el-dialog>
  <el-dialog 
  v-else
  v-model="isvisible"
  :visible.sync="isvisible" 
  :show-close="restrictedTime?true:true"
  :close-on-click-modal="false"
  :close-on-press-escape="false"
  :lock-scroll="false"
  append-to-body
  :class="isMobile ? 'rcdialog rcmobile' : 'rcdialog' "
  @close="closeRC(true)"
  >
    <div slot="title">
      <h3>Information!</h3>
    </div>
    <div style="display: grid;place-items: center;height: 100%;">
      <div style="margin: auto;">
        <div style="display: grid;place-items: center;height: 100%;">
          <img alt="Data is empty" style="text-align: center;" src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjQiIGhlaWdodD0iNDEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAxKSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxlbGxpcHNlIGZpbGw9IiNGNUY1RjUiIGN4PSIzMiIgY3k9IjMzIiByeD0iMzIiIHJ5PSI3Ii8+CiAgICA8ZyBmaWxsLXJ1bGU9Im5vbnplcm8iIHN0cm9rZT0iI0Q5RDlEOSI+CiAgICAgIDxwYXRoIGQ9Ik01NSAxMi43Nkw0NC44NTQgMS4yNThDNDQuMzY3LjQ3NCA0My42NTYgMCA0Mi45MDcgMEgyMS4wOTNjLS43NDkgMC0xLjQ2LjQ3NC0xLjk0NyAxLjI1N0w5IDEyLjc2MVYyMmg0NnYtOS4yNHoiLz4KICAgICAgPHBhdGggZD0iTTQxLjYxMyAxNS45MzFjMC0xLjYwNS45OTQtMi45MyAyLjIyNy0yLjkzMUg1NXYxOC4xMzdDNTUgMzMuMjYgNTMuNjggMzUgNTIuMDUgMzVoLTQwLjFDMTAuMzIgMzUgOSAzMy4yNTkgOSAzMS4xMzdWMTNoMTEuMTZjMS4yMzMgMCAyLjIyNyAxLjMyMyAyLjIyNyAyLjkyOHYuMDIyYzAgMS42MDUgMS4wMDUgMi45MDEgMi4yMzcgMi45MDFoMTQuNzUyYzEuMjMyIDAgMi4yMzctMS4zMDggMi4yMzctMi45MTN2LS4wMDd6IiBmaWxsPSIjRkFGQUZBIi8+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K"></img>
        </div>
        <div style="margin-top: 1rem;">
          <span>Sistem Rating Periodic sedang dalam Perbaikan / Update!</span>
        </div>
      </div>
    </div>
  </el-dialog>
</template>
<script>
  import { mapGetters } from "vuex";
  import axios from "axios";
  export default {
    name: "RC_form",
    props: {
      visible: Boolean,
      params: Object,
      restrictedTime: Boolean,
    },
    data() {
      return {
        activeServices:{
          index: 0,
          processed: 0,
          activeNames: [0,1,2],
          periode: "",
          dtl: [],
          note:""
        },
        isvisible: null,
        isEndRC: false,
        currentPeriode: "",
        underConstruction: false,
      };
    },
    mounted(){
    },
    computed: {
      ...mapGetters({
        activeUser: "getActiveUser",
      })
    },
    methods: {
      handleClose(done) {
        this.$confirm('Are you sure to close this dialog?')
          .then(_ => {
            done();
          })
          .catch(_ => {});
      },
      setActiveServices(index) {
        this.activeServices.index = index
        this.activeServices.dtl = this.params.data[index]

        let idx = []
        this.params.data.forEach((element,index) => {
          idx.push(index)
        });
        this.activeServices.activeNames = idx
        this.countingSts()
      },
      countingSts(){
        let temdt = this.params.data
        let countyet = 0
        temdt.forEach(element => {
          let sts = 'On Process'
          element.criteria.forEach(element2 => {
            element2['isInvalid_entry'] = ""
            if(element2.ratting_value!=null && element2.ratting_value!=0) sts='Processed'
          })
          element['sts'] = sts

          if(sts=='Processed'){
            countyet +=1
          }
        });
        Event.$emit("emitRC", temdt);
        this.activeServices.processed= countyet
      },
      async next(e){
        if(this.activeServices.index==(this.params.data.length-1)){
          this.isEndRC = true
        }else{
          this.isEndRC = false
        }

        let sts = true
        let invalids = false
        let invalids_idx = null
        this.activeServices.dtl.criteria.forEach((element2,index) => {
          if(element2.ratting_value==null || element2.ratting_value==0) sts=false
          if(element2.ratting_value>0 && element2.ratting_value<=3 && (element2.note ?? '').trim().length<10){
            if(invalids_idx==null) invalids_idx = index
            invalids = true
            this.activeServices.dtl.criteria[index]['isInvalid_entry'] = 
              (this.activeServices.dtl.criteria[index].note ?? '').trim().length>1 &&
              (this.activeServices.dtl.criteria[index].note ?? '').trim().length<10 ?
            "Min 10 Character!" : "Can't be empty!"
          }
        })

        if(!sts){
          e.preventDefault()
          this.isEndRC = false
          this.$notify.warning({
            title: "Warning",
            message: 'Please Complete the Essay!',
          });
          return
        }else if(invalids){
          this.isEndRC = false        
          this.$refs['inputcauses'+invalids_idx].focus()  
          this.$notify.warning({
            title: "Warning",
            message: "Rating Star <=3, it's must be entry the note!",
          });
          return
        }else {
          let user = JSON.parse(localStorage.getItem("token"));
          let id_criteria = []
          let ratting_value = []
          let note = []
          this.activeServices.dtl.criteria.forEach(element => {
            id_criteria.push(element.id)
            ratting_value.push(element.ratting_value?element.ratting_value:0)
            note.push(element.note?element.note:"")
          });
          this.currentPeriode = this.activeServices.dtl.periode

          await axios({
            method: "post",
            url: process.env.VUE_APP_BACKEND + "api/serviceRating",
            headers: {
              "Content-Type": "application/json",
              token: user.token,
            },
            data: {
              id_criteria,
              ratting_value,
              note
            },
          })
          .then((response) => {
            this.setActiveServices(this.activeServices.index+(this.isEndRC?0:1))
            if(this.isEndRC){
              Event.$emit("emitGetRC");
            }
          })
          .catch((error) => {
            this.$notify.warning({
              title: "Error",
              message: 'Error Save Service Rating!',
            });
            this.setActiveServices(this.activeServices.index)
          });
        }
      },prev(){
        this.isEndRC = false
        this.setActiveServices(this.activeServices.index-1)
      },
      setactiveSR(){
        let temdt = this.params.data
        let isprocessed = true
        temdt.forEach((element, index) => {
          if(isprocessed){
            element.criteria.forEach(element2 => {
              if(element2.ratting_value==null || element2.ratting_value==0){
                isprocessed=false
              }
            })
            if(!isprocessed) {
              this.activeServices.index = index;
            }
          }
        });
      },
      closeRC(isunderconstruction){
        this.isEndRC = false
        if(!isunderconstruction){
          this.setactiveSR()
          this.setActiveServices(this.activeServices.index)
        }
        Event.$emit("emitCloseRC");
      },
      validatenote(inpt, idx){
        if(this.activeServices.dtl.criteria[idx].ratting_value<=3){
          if((inpt ?? '').trim().length>10){
            this.activeServices.dtl.criteria[idx].isInvalid_entry = ""
          }else{
            this.activeServices.dtl.criteria[idx].isInvalid_entry = "Min 10 Character!"
          }
        }
      },
      changerate(inpt, idx){
          this.activeServices.dtl.criteria[idx].isInvalid_entry = 
            (inpt<=3 ? (
                          (this.activeServices.dtl.criteria[idx].note ?? '').trim().length>1 &&
                          (this.activeServices.dtl.criteria[idx].note ?? '').trim().length<10
              ? "Min 10 Character!" : "Can't be empty!") : "")
      }
    },
    watch: {
      visible(val) {
        this.isvisible = val;
      },
      "params.data"(){
        if(this.params.data.length>0) {
          this.setactiveSR()
          this.setActiveServices(this.activeServices.index)
        }
      },
      "activeServices.dtl.periode"(){
        if(this.currentPeriode!=this.activeServices.dtl.periode && this.isEndRC) {
          this.isEndRC = false
          this.$notify.success({
            title: "Success",
            message: 'Service Rating Essay '+this.currentPeriode+' is Completed, Please Entry The Next Service Rating Period!',
          });
        }else if(this.isEndRC){
          this.$notify.success({
            title: "Success",
            message: 'Service Rating Essay Periode Is Completed!',
          });
        }
      }
    },
  };
</script>
<style lang="scss">
.rating-val > .el-rate__item > .el-rate__icon{
  font-size: 24px!important;
}

.cnote {
  margin-top: $space;
}

.rcdialog{
  .el-dialog{
    width: 500px;
    display: flex;
    flex-direction: column;
  }
  .el-dialog__header{
    display: flex;
    flex-direction: column;
  }
  .el-dialog__body{
    display: flex;
    flex: 2;
    flex-direction: column;
    overflow: auto;
  }
  .el-dialog__footer{
    display: flex;
    flex-direction: column;
  }

  .el-dialog__body{
    padding: 0px 20px 0px 20px!important;
  }

  .el-table td{
    padding: 6px 0!important;
  }

  .el-divider--horizontal{
    margin: 25px 0 10px 0 !important;
  }
}

.rcmobile{
  .el-dialog {
    margin: 25px!important;
    width: 100%;
  }
}

.m-top {
  margin-top: $space*2;
}

.t-center{
  text-align:center;
}

.stepTitle{
  display: flex;
  justify-content: space-between;
}

.el-steps{
  justify-content: center;
}

.essayContent{
  display: flex;
}

.essayContent-input{
  width: 50%;
}

.h-tooltips{
  cursor: pointer;
}
.content-tooltips{
  max-width: 250px;
  text-wrap: wrap;
}
</style>